

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const LOGINEMPLOYEE= createAsyncThunk(
  "loginEmployee/loginEmployee",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const loginEmployeeSlice = createSlice({
  name: "loginEmployeeSlice",
  initialState: {
    loginEmployee: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfloginEmployee: (state) => {
        state.loginEmployee.loading = false
        state.loginEmployee.error = false
        state.loginEmployee.data = []
        state.loginEmployee.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(LOGINEMPLOYEE.fulfilled, (state, action) => {
      state.loginEmployee = {
        ...state.loginEmployee,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINEMPLOYEE.pending, (state, action) => {
      state.loginEmployee = {
        ...state.loginEmployee,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(LOGINEMPLOYEE.rejected, (state, action) => {
      state.loginEmployee = {
        ...state.loginEmployee,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const loginEmployeeAction = {
    LOGINEMPLOYEE,
};

export { loginEmployeeAction };
export default loginEmployeeSlice.reducer;
export const {setInitialStateOfloginEmployee} = loginEmployeeSlice.actions
